// Flow types automatically removed

import PropTypes from 'prop-types';
import { mobile as mobileCheck } from 'dibs-client-check';
import { FormattedMessage } from 'dibs-react-intl';
import { Button } from 'dibs-elements/exports/Button';
import styles from '../styles/copyToClipboard.scss';
export const copyToClipboard = ({ url, onClickCopyLink }) => {
    const temp = document.createElement('input');
    temp.setAttribute('value', url);

    if (document.body) {
        // the flow type of body is HTMLBodyElement or null
        document.body.appendChild(temp);
    }

    temp.select();
    document.execCommand('copy');

    if (document.body) {
        // the flow type of body is HTMLBodyElement or null
        document.body.removeChild(temp);
    }

    onClickCopyLink();
};
export const copyToClipboardWrapper =
    ({ url, onClickCopyLink }) =>
    () =>
        copyToClipboard({
            url,
            onClickCopyLink,
        });
export const CopyUrlElement = ({ url, type, onClickCopyLink }) => {
    return (
        <div className={styles.shareLink}>
            <div className={styles.linkBox}>
                <span data-tn="share-portfolio-link-text" className={styles.url}>
                    {url}
                </span>
            </div>
            <Button
                dataTn="copy-to-clipboard"
                onClick={copyToClipboardWrapper({
                    url,
                    onClickCopyLink,
                })}
            >
                <FormattedMessage
                    id="shareModal.clipboard.copy"
                    defaultMessage={`
                        {type, select,
                            INVOICE {Copy Link}
                            other {copy}
                        }
                    `}
                    values={{
                        type,
                    }}
                />
            </Button>
        </div>
    );
};
CopyUrlElement.propTypes = {
    onClickCopyLink: PropTypes.func.isRequired,
    url: PropTypes.string.isRequired,
    type: PropTypes.string,
};

const CopyToClipboard = ({ url, type, onClickCopyLink, customCopy }) => {
    if (mobileCheck.any()) {
        return (
            <div
                className={styles.linkCopyMobile}
                onClick={copyToClipboardWrapper({
                    url,
                    onClickCopyLink,
                })}
            >
                <FormattedMessage id="shareModal.clipboard.copy_url" defaultMessage="Copy url" />
            </div>
        );
    }

    return (
        <div className={styles.box}>
            <div className={styles.title}>
                {customCopy ? (
                    customCopy
                ) : (
                    <FormattedMessage
                        id="shareModal.clipboard.description"
                        defaultMessage="Send a link by copy pasting this url:"
                    />
                )}
            </div>
            <CopyUrlElement url={url} type={type} onClickCopyLink={onClickCopyLink} />
        </div>
    );
};

CopyToClipboard.propTypes = {
    onClickCopyLink: PropTypes.func.isRequired,
    url: PropTypes.string.isRequired,
    type: PropTypes.string,
    customCopy: PropTypes.object,
};
CopyToClipboard.defaultProps = {
    onClickCopyLink: () => {},
};
export default CopyToClipboard;
